import { config } from './img-optimize-config'

export function getImageTransformationUrl(props) {
  const { src, width } = props
  const url = src.png || src
  try {
    if (!url || config.is_enabled === false) {
      return url
    }

    const uri = new URL(url)
    const lastPathSegment = uri.pathname.split('/').pop()

    if (
      lastPathSegment &&
      config.supported_extensions.some(ext => lastPathSegment.includes(ext))
    ) {
      const path = uri.pathname
      if (
        !path ||
        !config.matching_paths.some(matchingPath => path.includes(matchingPath))
      ) {
        return applyTransformationV2({ uri, width })
      } else {
        return url
      }
    } else {
      return url
    }
  } catch (exception) {
    console.error(
      'Image transformation error: url=',
      url,
      ', exception=',
      exception,
    )
    return url
  }
}

/**
 * Prepends transformation URL to the image URL while assuming the config is not empty.
 */
function applyTransformationV2({ uri, width }) {
  const transformationUrl = config.host_transformation_url_map[uri.host]
  if (transformationUrl) {
    let urlString = `${transformationUrl}/quality=${config.quality},format=${config.format}`
    if (width) {
      let optimizedWidth: number = width
      if (config.imgOptimizingPercent) {
        optimizedWidth += (width * config.imgOptimizingPercent) / 100
      }
      urlString += `,width=${optimizedWidth}`
    }
    urlString += `/${uri}`
    return urlString
  } else {
    return uri.toString()
  }
}
